import type { components } from "@contracts/generated/editor-service";

/**
 * Tenant packs a project can start from (ADR 0008 addendum). The names come from
 * `GET /v1/tenant-packs`; this only checks the slug shape the server enforces.
 */
export type TenantPackName =
  components["schemas"]["CreateProjectFromTenantPack"]["tenantPack"];

export function isTenantPackName(value: string): value is TenantPackName {
  return /^[a-z0-9][a-z0-9_-]{0,62}$/.test(value);
}

/**
 * The "anxiety files only" preset: the pack-relative globs the pilot track
 * starts from — the anxiety dynamic evals and the classification reasoning
 * instructions, for whichever languages the pack carries. Sent as
 * `includePaths`; omitting it records every pack file.
 */
export const ANXIETY_ONLY_INCLUDE_PATHS = [
  "conversation_agent/*/dynamic_evals/anxiety/**",
  "conversation_agent/*/classification_reasoning_instructions.txt",
] as const;

/**
 * The overview's one-line provenance for a project started from a tenant pack:
 * "Based on tenant pack sheba @ 2026.08.3, 35 files". The revision is omitted
 * when the pack did not declare one, never invented.
 */
export function tenantPackBasisLabel(
  basis: components["schemas"]["TenantPackProvenance"],
): string {
  const revision = basis.packRevision ? ` @ ${basis.packRevision}` : "";
  const files = `${basis.fileCount} ${basis.fileCount === 1 ? "file" : "files"}`;
  return `Based on tenant pack ${basis.tenantPack}${revision}, ${files}`;
}
